import Bar from '../../components/Incidents/charts/Bar';
import { useMemo } from 'react';

const accumulateSum = (block) => {
  return block.data.reduce((acc, value) => (acc += value), 0);
};

const processUnitResponses = (unitResponses) => {
  // Extract the unit names (keys) for xLabels
  const xLabels = Object.keys(unitResponses);

  // Create a set of all incident types across all units (e.g., "Fire", "Medical", "Noemerg")
  const incidentTypes = Array.from(
    new Set(Object.values(unitResponses).flatMap((unit) => Object.keys(unit)))
  );

  // Generate series for each incident type
  const series = incidentTypes
    .map((type) => {
      const data = xLabels.map((unit) => {
        // Check if the unit has the incident type and use its value, otherwise default to 0
        return unitResponses[unit][type] || 0;
      });
      return { data, label: type, id: `${type}Id`, stack: 'total' };
    })
    // sort from bigger to smaller
    .sort((a, b) => accumulateSum(b) - accumulateSum(a));

  return { xLabels, series };
};

const IncidentByUnitChart = ({ data }) => {
  const { xLabels, series } = useMemo(
    () => processUnitResponses(data || {}),
    [data]
  );

  return <Bar xLabels={xLabels} series={series} />;
};

export default IncidentByUnitChart;
